'use strict';

import $ from 'jquery';

export default class Cookie {
  constructor(name) {
    if (this._getCookie(name) == null && $('.cookie-note--wrap').length > 0) {
      $.getScript( 'https://cdn.jsdelivr.net/npm/js-cookie@2.2.0/src/js.cookie.min.js', () => {
        this._cookieNotification(name);
      });
    }
  }

  _getCookie(name) {
    let dc = document.cookie;
    let prefix = name + "=";
    let begin = dc.indexOf("; " + prefix);
    let end = document.cookie.indexOf(";", begin);
    if (begin == -1) {
      begin = dc.indexOf(prefix);
      if (begin != 0) return null;
    } else {
      begin += 2;
      end = document.cookie.indexOf(";", begin);
      if (end == -1) {
        end = dc.length;
      }
    }
    // because unescape has been deprecated, replaced with decodeURI
    //return unescape(dc.substring(begin + prefix.length, end));
    return decodeURI(dc.substring(begin + prefix.length, end));
  };

  _cookieNotification(name) {
    if (typeof Cookies.get(name) === 'undefined') {
      setTimeout(() => { $('.cookie-note--wrap').addClass('is-visible')}, 1500);
    }

    $('.cookie-note--wrap').on('click', '.cookie-button-ok a', function(e) {
      e.preventDefault();
      Cookies.set(name, 1, { expires: 14 });
      $('.cookie-note--wrap').removeClass('is-visible');
    });
  };
}
